import makeApiRequest from './makeApiRequest';

const makeSession = () => {
	const postApiRequest = makeApiRequest('POST');
	const addSession = async (apiBase: string, fairId: any) => postApiRequest(`${apiBase}/api/session?fairId=${fairId}`, {});

	return [addSession];
};

export default makeSession;
